var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.currEvent
    ? _c(
        "modal",
        {
          staticClass: "c-event-modal",
          attrs: { name: "event", height: "auto", adaptive: true, width: 450 },
        },
        [
          _c("header", { staticClass: "c-event-modal__header" }, [
            _c("img", {
              staticClass: "c-event-modal__image",
              attrs: {
                src: _vm.currEvent.backgroundImage,
                alt: _vm.currEvent.name,
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "c-event-modal__header-content" }, [
              _c("h2", { staticClass: "c-event-modal__location" }, [
                _vm._v(_vm._s(_vm.currEvent.eventName)),
              ]),
              _vm._v(" "),
              _c("h3", { staticClass: "c-event-modal__date" }, [
                _vm._v(_vm._s(_vm.currEvent.timeRange)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-event-modal__content" }, [
            _c("h2", { staticClass: "c-event-modal__title" }, [
              _vm._v(_vm._s(_vm.currEvent.popupTitle)),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "c-event-modal__copy" }, [
              _vm._v(_vm._s(_vm.currEvent.popupCopy)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-event-modal__cta" },
            [
              _c(
                "router-link",
                {
                  staticClass: "btn btn--primary c-event-modal__btn",
                  attrs: { to: "/register/event" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.resetState()
                    },
                  },
                },
                [_vm._v("Sign up")]
              ),
              _vm._v(" "),
              _c("a", { attrs: { href: "" } }),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }